namespace Matrix.Data {
    export interface ExtensionFieldParseViewRequest extends Serenity.ServiceRequest {
        TableSchema?: string;
        Tablename?: string;
    }
}
